import React, { Component } from "react";
import MainPage from "./MainPage";
import SearchFriends from "./SearchFriends";
import Settings from "./Settings";
import SignInScreen from "./SignInScreen";
import * as k from "./constants";
import { getMessages, countfollow } from "./dao/post";

class Main extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentUserId: this.props.appProps.state.userid,
      messages: [],
      follower: 0,
      following: 0,
      displayPost: "",
      loading: true,
      search: [],
    };
  }

  handleState = (name, val) => {
    this.setState({
      [name]: val,
    });
  };

  componentDidMount() {
    if (this.state.currentUserId !== "") {
      //this.getMessages(this.props.appProps.state.userid);
      let userid = this.props.appProps.state.userid;
      getMessages(userid, this);
    }
  }

  shouldComponentUpdate(nextProp) {
    if (
      nextProp.appProps.state.userid !== this.state.currentUserId &&
      nextProp.appProps.state.userid !== ""
    ) {
      this.setState({
        currentUserId: nextProp.appProps.state.userid,
        loading: true,
        messages: [],
        search: [],
      });
      //this.getMessages(nextProp.appProps.state.userid);
      let userid = this.props.appProps.state.userid;
      getMessages(userid, this);
      console.log("should mount main");

      countfollow(userid, "following", (res) => {
        console.log("total following", res);
        this.setState({
          following: res.total,
        });
      });
      countfollow(userid, "follower", (res) => {
        console.log("total follower", res);
        this.setState({
          follower: res.total,
        });
      });
    }
    return true;
  }

  render() {
    let { authorized, currentScreen } = this.props.appProps.state;

    if (authorized && currentScreen === k.HOME) {
      return <MainPage appProps={this.props.appProps} mainCtrlProps={this} />;
    } else if (authorized && currentScreen === k.SEARCH) {
      return (
        <SearchFriends appProps={this.props.appProps} mainCtrlProps={this} />
      );
    } else if (authorized && currentScreen === k.SETTINGS) {
      return <Settings appProps={this.props.appProps} mainCtrlProps={this} />;
    } else {
      return <SignInScreen appProps={this.props.appProps} />;
    }
  }
}

export default Main;
